var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.articles.length)?_c('carousel',{attrs:{"perPage":1}},_vm._l((_vm.articles),function(article,index){return _c('slide',{key:article.author},[_c('router-link',{attrs:{"to":("/article/" + (index + 1))}},[_c('Article',{attrs:{"id":index + 1}})],1)],1)})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af6aaf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 135
// module chunks = 1